export enum EntityApplications {
  portal = 'portal',
  pwaPortal = 'pwaPortal',
  crm = 'crm',
}

export const entityApplicationNameList = Object.keys(EntityApplications);
